import { useCallback } from "react";
import { useGetVehicleDetails } from '../apis/drivers/use-get-vehichle-type';

type VehicleType = {
  label: string;
  value: string;
};

const DEFAULT_VEHICLE_TYPES: VehicleType[] = [
  { label: "Sedan Coupe", value: "sedan_coupe" },
  { label: "Suv", value: "suv" },
  { label: "Pickup Truck", value: "pickup_truck" },
  { label: "Pickup Truck", value: "pickupTruck" },
  { label: "Van", value: "van" },
  { label: "Car", value: "car" },
  { label: "Other", value: "other" },
];

const useVehicleTypes = () => {
  const { data } = useGetVehicleDetails();

  const vehicleTypes: VehicleType[] = [
    ...DEFAULT_VEHICLE_TYPES,
    ...(data?.types ?? []),
  ];

  const getVehicleLabel = useCallback(
    (type: string) =>
      vehicleTypes.find(
        (item) => item.value?.toLowerCase() === type?.toLowerCase()
      )?.label ?? "N/A",
    [vehicleTypes]
  );

  return {
    vehicleTypes,
    getVehicleLabel,
  };
};

export default useVehicleTypes;